// ============================================
// carritoOrigen.js — REGLA DE DINERO compartida para volcar items al carrito
// ============================================
// Extraido TAL CUAL de Colecciones.js agregarAlCarrito para que la regla de
// precio viva en UN solo lugar y NO diverja entre la vista de Colecciones y el
// Motor de Origen del cotizador (Fase 2).
//
// REGLA DE DINERO (no cambiar):
//  - Item CONGELADO y VIGENTE (o por vencer): se manda el precio congelado como
//    precio_forzado_mxn + snapshot de costo/margen/origen/moneda. El carrito NO
//    recalcula el de hoy (queda como precio pactado / bloqueado).
//  - Item CONGELADO pero VENCIDO, o NO congelado: extra = {} -> el backend usa el
//    precio de HOY. Para variables NO congelados se respeta la variante elegida
//    via prod.referencia_id (ej. "5:12").
//
// `prod` es opcional: viene de la tarjeta de tienda y, para productos variables NO
// congelados, trae el referencia_id con la variante elegida. Si no se pasa, se usa
// el referencia_id del propio item.
//
// Devuelve { tipo, referencia_id, extra, congeladoVigente } listo para
// agregarItem({ tipo, referencia_id }, cantidad, extra). `congeladoVigente` se
// expone para que la UI arme su etiqueta ("precio congelado" vs "precio de hoy").
export function construirAgregadoDesdeItemColeccion(item, prod = null) {
  // REGLA DE DINERO: solo se respeta el precio congelado si esta VIGENTE (o por vencer).
  // Si el congelado ya VENCIO, se manda el precio de HOY (no el viejo).
  const congeladoVigente = item.congelado === true
    && item.precio_congelado_mxn != null
    && item.congelado_estado !== 'vencido';
  const extra = congeladoVigente
    ? {
        precio_forzado_mxn: item.precio_congelado_mxn,
        costo_snapshot_mxn: item.costo_snapshot_mxn,
        margen_snapshot_pct: item.margen_snapshot_pct,
        precio_origen: item.precio_origen,
        moneda_origen: item.moneda_origen,
      }
    : {};
  // refId: el de la variante elegida (solo cuando NO se fuerza precio), si no el del item.
  const referencia_id = (!congeladoVigente && prod && prod.referencia_id) ? prod.referencia_id : item.referencia_id;
  return { tipo: item.tipo, referencia_id, extra, congeladoVigente };
}
